/* ==========================================================================
   RK PRODUCT JS
   Moved out of templates/product.json custom_liquid blocks.
   Loaded deferred from theme.liquid. Product pages only.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     1. SAT BADGE — smooth scroll to the Judge.me widget
        Markup: .rk-sat  (block custom_liquid_N8qtbi)
     ------------------------------------------------------------------ */
  function initSatBadge() {
    var link = document.querySelector('.rk-sat');
    if (!link || link.dataset.rkInit) return;
    link.dataset.rkInit = '1';

    var OFFSET = 120; // sticky header clearance — tune to your header height

    link.addEventListener('click', function (e) {
      var target = document.getElementById('judgeme_product_reviews');
      if (!target) return; // widget not loaded yet -> native anchor jump
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
      window.scrollTo({
        top: top,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      if (history.replaceState) history.replaceState(null, '', '#judgeme_product_reviews');
    });
  }

  /* ------------------------------------------------------------------
     2. PROMO PILL — apply button, applied state, variant price sync
        Markup: [data-rk-promo]  (block custom_liquid_rk_promo)

        Renders only when shop metafields custom.promo_code and
        custom.promo_percent are set. No countdown unless a real end
        time is supplied: add data-promo-ends="2026-09-30T23:59:00Z"
        to the .rk-promo div and the clock counts down to it once,
        then hides the pill for good. With no end time the "ends in"
        line is removed so nothing false is shown.
     ------------------------------------------------------------------ */
  function initPromo() {
    var root = document.querySelector('[data-rk-promo]');
    if (!root || root.dataset.rkInit) return;
    root.dataset.rkInit = '1';

    var code = (root.getAttribute('data-promo-code') || '').toUpperCase();
    var pct = parseFloat(root.getAttribute('data-promo-pct')) || 0;
    var endsAttr = root.getAttribute('data-promo-ends');
    var applied = root.querySelector('[data-rk-promo-applied]');
    var btn = root.querySelector('[data-rk-promo-apply]');
    var amountEl = root.querySelector('[data-rk-promo-amount]');
    var clock = root.querySelector('[data-rk-clock]');
    var meta = root.querySelector('.rk-promo__meta');

    /* ---------- visibility + optional real countdown ---------- */
    var endsAt = endsAttr ? Date.parse(endsAttr) : NaN;
    var timeoutId = null;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var left = Math.floor((endsAt - Date.now()) / 1000);
      if (left <= 0) { root.hidden = true; return; }
      root.hidden = false;
      if (clock) {
        clock.textContent =
          pad(Math.floor(left / 3600)) + ':' +
          pad(Math.floor((left % 3600) / 60)) + ':' +
          pad(left % 60);
      }
      timeoutId = setTimeout(tick, document.hidden ? 30000 : 1000);
    }

    if (!isNaN(endsAt)) {
      tick();
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) { clearTimeout(timeoutId); tick(); }
      });
    } else {
      // no real deadline configured — show the offer, drop the "ends in" line
      if (meta) meta.remove();
      root.hidden = false;
    }

    if (root.hidden) return;

    /* ---------- applied state ---------- */
    function setApplied(on) {
      if (on) {
        if (btn) btn.style.display = 'none';
        if (applied) applied.style.display = 'flex';
      } else {
        if (btn) btn.style.display = '';
        if (applied) applied.style.display = 'none';
      }
    }

    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        try { return window.Shopify.formatMoney(cents); } catch (e) {}
      }
      try {
        var currency =
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
          root.getAttribute('data-currency') || 'USD';
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency })
          .format(cents / 100);
      } catch (e) { return '$' + (cents / 100).toFixed(2); }
    }

    function updateAmount(priceCents) {
      if (!amountEl || !priceCents) return;
      amountEl.textContent = formatMoney(Math.round(priceCents * pct / 100));
    }

    function verifyCart() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var found = false;
          (cart.discount_codes || []).forEach(function (d) {
            if ((d.code || '').toUpperCase() === code && d.applicable !== false) found = true;
          });
          (cart.cart_level_discount_applications || []).forEach(function (d) {
            if ((d.title || '').toUpperCase() === code) found = true;
          });
          if (found) {
            try { localStorage.setItem('rk_promo_applied', code); } catch (e) {}
            setApplied(true);
          } else {
            try {
              if (localStorage.getItem('rk_promo_applied') === code) {
                localStorage.removeItem('rk_promo_applied');
              }
            } catch (e) {}
            setApplied(false);
          }
        })
        .catch(function () {});
    }

    try {
      if (localStorage.getItem('rk_promo_applied') === code) setApplied(true);
    } catch (e) {}
    (window.requestIdleCallback || function (cb) { return setTimeout(cb, 1500); })(
      verifyCart, { timeout: 3000 }
    );

    if (btn) {
      btn.addEventListener('click', function () {
        fetch('/discount/' + encodeURIComponent(code), {
          credentials: 'same-origin', redirect: 'follow'
        })
          .then(function () {
            try { localStorage.setItem('rk_promo_applied', code); } catch (e) {}
            setApplied(true);
            if (window.PUB_SUB_EVENTS && window.publish) {
              try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, {}); } catch (e) {}
            }
          })
          .catch(function () {
            window.location.href = '/discount/' + encodeURIComponent(code) +
              '?redirect=' + encodeURIComponent(window.location.pathname);
          });
      });
    }

    /* ---------- keep the discount amount in sync with the variant ----------
       Reads the product JSON already embedded in the page when available,
       so no extra network request on variant change. */
    function handleVariant(v) {
      if (v && typeof v.price === 'number') updateAmount(v.price);
    }

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (ev) {
          if (ev && ev.data && ev.data.variant) handleVariant(ev.data.variant);
        });
      } catch (e) {}
    }

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) handleVariant(e.detail.variant);
    });

    var variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (variantInput) {
      variantInput.addEventListener('change', function () {
        var id = variantInput.value;
        if (!id) return;

        // try the in-page product JSON first
        var json = document.querySelector('[type="application/json"][data-product-json], #ProductJson-product-template');
        if (json) {
          try {
            var p = JSON.parse(json.textContent);
            var match = (p.variants || []).filter(function (x) {
              return String(x.id) === String(id);
            })[0];
            if (match) { updateAmount(match.price); return; }
          } catch (e) {}
        }

        // fall back to a fetch only if the JSON isn't on the page
        var handle = (window.location.pathname.match(/\/products\/([^\/\?#]+)/) || [])[1];
        if (!handle) return;
        fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (p) {
            var v = (p.variants || []).filter(function (x) {
              return String(x.id) === String(id);
            })[0];
            if (v) updateAmount(v.price);
          })
          .catch(function () {});
      });
    }
  }

  /* ------------------------------------------------------------------
     3. GALLERY THUMBS — scrollable thumbnail column, desktop only
        Applies .rk-thumb-scrollable; styling lives in theme.css.
     ------------------------------------------------------------------ */
  var THUMB_BREAKPOINT = 750;
  var THUMB_SELECTORS = [
    '.thumbnail-list',
    '.product__thumbs ul',
    '.product-thumbnails',
    '.product-gallery__thumbnails',
    '.product__media-thumbnails',
    '.product-single__thumbnails',
    '[data-product-thumbnails]'
  ];

  function findThumbs() {
    for (var i = 0; i < THUMB_SELECTORS.length; i++) {
      var el = document.querySelector(THUMB_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function attachThumbs(thumbs) {
    if (!thumbs || thumbs.dataset.rkScrollInit) return;
    thumbs.dataset.rkScrollInit = '1';
    thumbs.classList.add('rk-thumb-scrollable');
    thumbs.style.overflowY = 'auto';
    thumbs.style.maxHeight = '540px';
    thumbs.style.transform = 'none';
    thumbs.style.webkitOverflowScrolling = 'touch';
    thumbs.style.touchAction = 'pan-y';

    var parent = thumbs.parentElement;
    var depth = 0;
    while (parent && depth < 6) {
      parent.style.touchAction = 'pan-y';
      parent = parent.parentElement;
      depth++;
    }

    var observer = new MutationObserver(function () {
      if (!thumbs.classList.contains('rk-thumb-scrollable')) {
        thumbs.classList.add('rk-thumb-scrollable');
      }
      if (thumbs.style.overflowY !== 'auto') thumbs.style.overflowY = 'auto';
      if (thumbs.style.transform !== 'none') thumbs.style.transform = 'none';
    });
    observer.observe(thumbs, { attributes: true, attributeFilter: ['class', 'style'] });

    thumbs.addEventListener('touchmove', function (e) {
      e.stopPropagation();
    }, { passive: true, capture: true });

    var targetScroll = thumbs.scrollTop;
    var rafId = null;

    function animate() {
      var diff = targetScroll - thumbs.scrollTop;
      if (Math.abs(diff) < 0.5) { thumbs.scrollTop = targetScroll; rafId = null; return; }
      thumbs.scrollTop += diff * 0.18;
      rafId = requestAnimationFrame(animate);
    }

    thumbs.addEventListener('wheel', function (e) {
      var maxScroll = thumbs.scrollHeight - thumbs.clientHeight;
      if (maxScroll <= 0) return;
      var atTop = thumbs.scrollTop <= 0;
      var atBottom = thumbs.scrollTop >= maxScroll - 1;
      if ((e.deltaY > 0 && atBottom) || (e.deltaY < 0 && atTop)) return;
      e.preventDefault();
      targetScroll = Math.max(0, Math.min(maxScroll, targetScroll + e.deltaY));
      if (!rafId) rafId = requestAnimationFrame(animate);
    }, { passive: false });

    thumbs.addEventListener('click', function () {
      if (rafId) { cancelAnimationFrame(rafId); rafId = null; targetScroll = thumbs.scrollTop; }
    }, false);

    thumbs.addEventListener('scroll', function () {
      if (rafId === null) targetScroll = thumbs.scrollTop;
    });
  }

  function initThumbs() {
    if (window.innerWidth < THUMB_BREAKPOINT) return;
    var thumbs = findThumbs();
    if (thumbs) attachThumbs(thumbs);
  }

  /* ------------------------------------------------------------------
     BOOT
     ------------------------------------------------------------------ */
  function init() {
    initSatBadge();
    initPromo();
    initThumbs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', initThumbs);
  window.addEventListener('orientationchange', function () { setTimeout(initThumbs, 200); });
  window.addEventListener('resize', function () { setTimeout(initThumbs, 200); });
})();